module.exports = __webpack_public_path__ + "media/images/appIcon-205decd19573717702114b7067e99ad0.png";